import { NO, UIColor, UITextView, UIView } from "uicore-ts"
import { RHProcurement, RHProcurementPublic } from "../../../../models/prodModels"
import { RHFocusManager } from "../../Custom components/RH/Keyboard navigation/RHFocusManager"
import { RHBadgeView } from "../../Custom components/RH/RHBadgeView"
import { RHColors, RHFont, RHRadius, RHSpacing } from "../../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHCompanyQuestionsCardViewTokens } from "../../Custom components/RH/Utils_slop/RHViewTokens"
import { ProcurementQuestionAndAnswerThread } from "../../SocketClientFunctions"
import { QuestionAnswerPair, QuestionAnswerPairView } from "./QuestionAnswerPairView"
import { RHQuestionDialogView } from "./RHQuestionDialogView"

export class RHCompanyQuestionsCardView extends UIView {

    readonly contextBadge = new RHBadgeView().configuredWithObject({
        label: {
            backgroundColor: RHColors.primaryBlueSurface,
            textColor: RHColors.primaryBlue,
            style: { fontFamily: RHFont.familyBase, fontSize: RHFont.sizeMedium, fontWeight: "700", boxSizing: "border-box" }
        }
    })
    
    // Card header removed — each card now holds a SINGLE question and the company
    // name is part of the question's title. Kept commented for reference.
    // readonly headerView = new UIView()
    //     .addedAsSubviewToView(this)
    //
    // readonly companyNameLabel = new UITextView()
    //     .addedAsSubviewToView(this.headerView)
    //
    // readonly lastUpdateLabel = new UITextView()
    //     .addedAsSubviewToView(this.headerView)

    // Container for all question-answer pairs
    // readonly questionsContainer = new UIView()
    //     .addedAsSubviewToView(this)
    
    readonly questionDialogView = new RHQuestionDialogView()
    readonly questions: QuestionAnswerPair[] = []
    questionViews: QuestionAnswerPairView[] = []
    
    answerDidSubmit?: (questionId: string, answer?: string) => void
    
    readonly companyName: string
    readonly hasUnanswered: boolean
    procurement: RHProcurementPublic | RHProcurement
    
    _isLocked = NO
    _isCurrentUserActingAsProcurer = NO
    _canAnswerMessages = NO
    
    override _focusManager = new RHFocusManager(() => {
        const items: (UIView | RHFocusManager)[] = []
        for (const view of this.questionViews) {
            if (view._focusManager) {
                items.push(view._focusManager)
            }
        }
        return items as UIView[]
    })
    
    
    
    constructor(companyName: string, questions: ProcurementQuestionAndAnswerThread[], procurement: RHProcurementPublic | RHProcurement) {
        super()
        
        this.companyName = companyName
        this.procurement = procurement
        
        // Sort questions oldest to newest
        const sortedQuestions = questions.slice().sort((questionA, questionB) => {
            return new Date(questionA.createdAt).getTime() - new Date(questionB.createdAt).getTime()
        })
        
        this.questions = sortedQuestions.map(q => ({
            question: q,
            isAnswered: !!q.answerText
        }))
        
        this.hasUnanswered = this.questions.some(qa => !qa.isAnswered)
        
        let borderColor = RHColors.borderSlate
        if (this.hasUnanswered) {
            borderColor = RHColors.borderSlate
        }
        
        this.configureWithObject({
            // @ts-ignore
            backgroundColor: UIColor.whiteColor,
            // @ts-ignore
            style: {
                borderRadius: `${RHRadius.large}px`,
                border: `${1}px solid ${borderColor.stringValue}`,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                overflow: "hidden"
            }
        })
        
        // this.setupHeader()   // header removed — company now lives in the question title
        this.createQuestionViews()
    }
    
    
    set isLocked(isLocked: boolean) {
        this._isLocked = isLocked
        this.questionViews.everyElement.isLocked = isLocked
    }
    get isLocked() {
        return this._isLocked
    }

    
    set isCurrentUserActingAsProcurer(isCurrentUserActingAsProcurer: boolean) {
        this._isCurrentUserActingAsProcurer = isCurrentUserActingAsProcurer
        this.questionViews.everyElement.isCurrentUserActingAsProcurer = isCurrentUserActingAsProcurer
    }
    get isCurrentUserActingAsProcurer() {
        return this._isCurrentUserActingAsProcurer
    }


    set canAnswerMessages(value: boolean) {
        this._canAnswerMessages = value
        this.questionViews.everyElement.canAnswerMessages = value
    }
    get canAnswerMessages() {
        return this._canAnswerMessages
    }
    
    
    /* Header removed — kept commented for reference (single question per card now).
    private setupHeader() {
        // Header styling based on whether there are unanswered questions
        if (this.hasUnanswered) {
            this.headerView.backgroundColor = RHCompanyQuestionsCardViewTokens.unansweredHeaderBackground
            
            this.companyNameLabel.configuredWithObject({
                textAlignment: UITextView.textAlignment.left,
                style: {
                    fontWeight: RHCompanyQuestionsCardViewTokens.companyNameFontWeight,
                    fontSize: RHCompanyQuestionsCardViewTokens.companyNameFontSize,
                    fontFamily: RHCompanyQuestionsCardViewTokens.companyNameFontFamily,
                    letterSpacing: RHCompanyQuestionsCardViewTokens.companyNameLetterSpacing,
                    margin: "0",
                    color: RHCompanyQuestionsCardViewTokens.unansweredHeaderTextColor.stringValue
                }
            })
            
            this.lastUpdateLabel.configuredWithObject({
                textAlignment: UITextView.textAlignment.right,
                style: {
                    fontSize: RHCompanyQuestionsCardViewTokens.lastUpdateFontSize,
                    fontWeight: RHCompanyQuestionsCardViewTokens.lastUpdateFontWeight,
                    fontFamily: RHCompanyQuestionsCardViewTokens.lastUpdateFontFamily,
                    margin: "0",
                    color: RHCompanyQuestionsCardViewTokens.unansweredHeaderTextColor.stringValue
                }
            })
        }
        else {
            this.headerView.backgroundColor = RHCompanyQuestionsCardViewTokens.answeredHeaderBackground
            
            this.companyNameLabel.configuredWithObject({
                textAlignment: UITextView.textAlignment.left,
                style: {
                    fontWeight: RHCompanyQuestionsCardViewTokens.companyNameFontWeight,
                    fontSize: RHCompanyQuestionsCardViewTokens.companyNameFontSize,
                    fontFamily: RHCompanyQuestionsCardViewTokens.companyNameFontFamily,
                    letterSpacing: RHCompanyQuestionsCardViewTokens.companyNameLetterSpacing,
                    margin: "0",
                    color: RHCompanyQuestionsCardViewTokens.answeredHeaderTextColor.stringValue
                }
            })
            
            this.lastUpdateLabel.configuredWithObject({
                textAlignment: UITextView.textAlignment.right,
                style: {
                    fontSize: RHCompanyQuestionsCardViewTokens.lastUpdateFontSize,
                    fontWeight: RHCompanyQuestionsCardViewTokens.lastUpdateFontWeight,
                    fontFamily: RHCompanyQuestionsCardViewTokens.lastUpdateFontFamily,
                    margin: "0",
                    color: RHCompanyQuestionsCardViewTokens.answeredHeaderTextColor.stringValue
                }
            })
        }
        
        // companyName is already the server-resolved display name (real name for procurers,
        // "Anonüümne" for everyone else) — use it directly
        this.companyNameLabel.text = this.companyName || "Kasutaja"
        
        // Find the most recent update time
        const latestDate = this.questions.reduce((latest, qa) => {
            const questionDate = new Date(qa.question.updatedAt || qa.question.createdAt)
            return questionDate > latest ? questionDate : latest
        }, new Date(0))
        
        this.lastUpdateLabel.text = `Viimane: ${formatRHDateTime(latestDate)}`
    }
    */


    private createQuestionViews() {
        this.questionViews.forEach(view => view.removeFromSuperview())
        this.questionViews = []
        
        this.questions.forEach((qa, localIndex, array) => {
            const pairView = new QuestionAnswerPairView(
                qa.question,
                qa.isAnswered,
                array.length <= localIndex - 1
            ).addedAsSubviewToView(this)
            
            // Pass through the answer callback
            pairView.answerButtonWasPressed = () => {
                const procurement = { isCurrentUserCompanyRegisteredAsTenderer: NO, ...this.procurement }
                this.questionDialogView.showForQuestion(qa.question, procurement, (answer) => {
                    if (this.answerDidSubmit) {
                        this.answerDidSubmit(qa.question._id, answer)
                    }
                })
            }
            
            pairView.isCurrentUserActingAsProcurer = this._isCurrentUserActingAsProcurer
            pairView.canAnswerMessages = this._canAnswerMessages
            
            this.questionViews.push(pairView)
        })
    }
    
    
    override layoutSubviews() {
        super.layoutSubviews()
        
        const padding = this.core.paddingLength
        // Header removed — a top inset replaces the old header's leading space.
        // const headerHeight = RHCompanyQuestionsCardViewTokens.headerHeight
        const bounds = this.contentBoundsWithInsets(0, 0, padding, padding)
        // const lastUpdateWidth =
        //     this.lastUpdateLabel.intrinsicContentWidth(headerHeight) +
        //     RHCompanyQuestionsCardViewTokens.lastUpdateWidthSafetyBuffer
        //
        // // Header
        // this.headerView.frame = bounds.rectangleWithHeight(headerHeight)
        // this.headerView.contentBoundsWithInsets(
        //         RHCompanyQuestionsCardViewTokens.headerHorizontalPadding,
        //         RHCompanyQuestionsCardViewTokens.headerHorizontalPadding +
        //         RHCompanyQuestionsCardViewTokens.lastUpdateTrailingInset,
        //         RHCompanyQuestionsCardViewTokens.headerVerticalPadding,
        //         RHCompanyQuestionsCardViewTokens.headerVerticalPadding
        //     )
        //     .distributeViewsAlongWidth(
        //         [
        //             this.companyNameLabel,
        //             this.lastUpdateLabel
        //         ],
        //         1,
        //         RHCompanyQuestionsCardViewTokens.headerGap,
        //         [nil, lastUpdateWidth]
        //     )

        // Question (single per card) — starts from the top inset.
        bounds
            .IF(this.contextBadge.superview === this)
            .rectangleWithHeight(this.contextBadge)
            .rectangleByAddingX(RHSpacing.medium)
            .rectangleWithWidth(this.contextBadge)
            .assignedAsFrameOfView(this.contextBadge)
            .rectangleForNextRow(RHSpacing.small, 0)
            .rectangleWithX(bounds.x)
            .rectangleWithWidth(bounds.width)
            .ENDIF()
            .framesByDistributingViewsAsColumn(
                this.questionViews,
                0 // No padding between - separators are built into the views
            )

    }
    
    
    override intrinsicContentHeight(constrainingWidth?: number): number {

        const padding = this.core.paddingLength
        const width = constrainingWidth || this.bounds.width
        const effectiveWidth = width > 0 ? width : 300
        // Header removed: height is now top inset + question(s) + bottom inset.
        // let totalHeight = RHCompanyQuestionsCardViewTokens.headerHeight + padding
        let totalHeight = padding + padding
        if (this.contextBadge.superview === this) {
            totalHeight += this.contextBadge.intrinsicContentHeight(effectiveWidth) + RHSpacing.small
        }

        this.questionViews.forEach(view => {
            totalHeight += view.intrinsicContentHeight(effectiveWidth)
        })

        return totalHeight

    }
    
    // override intrinsicContentHeight(constrainingWidth?: number): number {
    //     const padding = this.core.paddingLength
    //     const width = constrainingWidth || this.bounds.width
    //     const effectiveWidth = width > 0 ? width : 300
    //
    //     let totalHeight = 0
    //
    //     // Header
    //     totalHeight += padding * 1.5
    //
    //     // All question-answer pairs
    //     this.questionViews.forEach(view => {
    //         totalHeight += view.intrinsicContentHeight(effectiveWidth)
    //     })
    //
    //     return totalHeight
    // }
    
}
